import { inject, Injectable } from '@angular/core';
import type { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import type { Observable } from 'rxjs';

import { EnvironmentService } from '@app/core/environment-service';

@Injectable({
  providedIn: 'root',
})
export class GamesGuard {
  readonly #router = inject(Router);
  readonly #environmentService = inject(EnvironmentService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const path = route.url[0]?.path ?? (route.routeConfig && route.routeConfig.path ? route.routeConfig.path : '');
    return this.#environmentService.gameIsOn(path) ? true : this.#router.navigate(['/'], { replaceUrl: true });
  }
}
